module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_chocolatey_milk_chocolate-b8f955d6.png";